// extracted by mini-css-extract-plugin
export default {"container":"TextArea_container__8IMd+","label":"TextArea_label__AnaLu","textarea":"TextArea_textarea__Lg5UY"};